<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-xl-12">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h5 style="color: blue; margin-bottom: 30px">
                {{ $t("menu.assiduite") }}
              </h5>
              <label>{{ $t("sms.listeClasses") }}</label>
              <a-select
                show-search
                :placeholder="$t('emploi.listeClasses')"
                option-filter-prop="children"
                :filter-option="filterOption"
                style="width: 150px; margin-left: 15px"
                @change="
                  (val) => {
                    handleClassChange('classe', val);
                  }
                "
              >
                <a-select-option value="all"> --- </a-select-option>
                <a-select-option
                  v-for="classe in classes"
                  :key="classe._id"
                  :value="classe._id"
                >
                  {{ classe.name }}
                </a-select-option>
              </a-select>

              <label style="margin-right: 5px; margin-left: 15px">{{
                $t("recette.date")
              }}</label>
              <a-date-picker
                style="width: 180px; margin-left: 5px"
                format="DD/MM/YYYY"
                v-model="selectedDate"
                @change="handleDateChange"
                :disabledDate="(current) => current > moment()"
                v-decorator="['start', { rules: [{ required: true }] }]"
              />

              <label style="margin-right: 5px; margin-left: 15px">{{
                $t("emploi.seance")
              }}</label>
              <a-select
                :placeholder="$t('emploi.seanceListe')"
                style="width: 180px; margin-left: 5px; margin-bottom: 10px"
                :loading="sessionLoading"
                v-model="selectedSession"
                @change="
                  (val) => {
                    this.selectedSession = val;
                    this.handleSessionChange();
                  }
                "
              >
                <a-select-option value="">
                  {{ $t("error.selectSeance") }}
                </a-select-option>
                <a-select-option
                  v-for="session in sessionList"
                  :key="session._id"
                  :value="session._id"
                >
                  {{ session.name }}
                </a-select-option>
              </a-select>
            </div>
            <a-button
              type="primary"
              style="margin-top: 47px"
              @click="openHistoryModal"
              v-if="selectedClasse"
            >
              <a-icon type="history" />{{ $t("action.imprimerHistorique") }}
            </a-button>
          </div>
          <div>
            <a-button
              type="primary"
              style="margin-right: 5px"
              :loading="printLoading"
              :disabled="printLoading"
              @click="generatePdf"
              v-if="selectedClasse && selectedSession"
            >
              <a-icon v-if="!printLoading" type="file-pdf" />{{
                $t("action.imprimer")
              }}
            </a-button>
          </div>

          <!-- Modal for history date range -->
          <a-modal
            :visible="showHistoryModal"
            :title="$t('action.imprimerHistorique')"
            @cancel="closeHistoryModal"
            :footer="null"
            width="500px"
          >
            <div style="padding: 20px 0">
              <div style="margin-bottom: 20px">
                <label
                  style="display: block; margin-bottom: 8px; font-weight: 500"
                >
                  {{ $t("etablissement.dateDebut") }}
                </label>
                <a-date-picker
                  style="width: 100%"
                  format="DD/MM/YYYY"
                  v-model="startDate"
                  :disabledDate="
                    (current) =>
                      current > moment() || (endDate && current > endDate)
                  "
                  :placeholder="
                    $t('recette.dateDebutPlaceholder') ||
                    'Sélectionner la date de début'
                  "
                />
              </div>

              <div style="margin-bottom: 20px">
                <label
                  style="display: block; margin-bottom: 8px; font-weight: 500"
                >
                  {{ $t("etablissement.dateFin") }}
                </label>
                <a-date-picker
                  style="width: 100%"
                  format="DD/MM/YYYY"
                  v-model="endDate"
                  :disabledDate="
                    (current) =>
                      current > moment() || (startDate && current < startDate)
                  "
                  :placeholder="
                    $t('recette.dateFinPlaceholder') ||
                    'Sélectionner la date de fin'
                  "
                />
              </div>

              <div style="text-align: right; margin-top: 30px">
                <a-button
                  type="default"
                  style="margin-right: 10px"
                  @click="closeHistoryModal"
                >
                  {{ $t("action.annuler") }}
                </a-button>
                <a-button
                  type="primary"
                  :loading="historyPrintLoading"
                  :disabled="historyPrintLoading || !startDate || !endDate"
                  @click="generateHistoryPdf"
                >
                  <a-icon v-if="!historyPrintLoading" type="file-pdf" />{{
                    $t("action.genererPdfHistorique")
                  }}
                </a-button>
              </div>
            </div>
          </a-modal>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-8">
          <div
            class="card"
            style="margin-top: 10px"
            v-if="selectedClasse && selectedSession"
          >
            <div class="data-table">
              <a-table
                @change="tableChanged"
                :loading="tableLoading"
                :pagination="true"
                :data-source="activeData"
                :columns="columns"
              >
                <template slot="mark" slot-scope="text, record">
                  <attendance
                    :student="record._id"
                    :schedule="selectedSession"
                    :type="getStudentAttendance(record._id)"
                    :id="getStudentAttendanceId(record._id)"
                    :date="selectedDate"
                    :classLevel="selectedLevel"
                    @attendanceUpdated="handleAttendanceUpdate"
                  />
                </template>

                <template slot="name" slot-scope="text, record">
                  <span>{{ record.fullName }}</span>
                </template>

                <div
                  slot="filterDropdown"
                  slot-scope="{
                    setSelectedKeys,
                    selectedKeys,
                    confirm,
                    clearFilters,
                    column,
                  }"
                  style="padding: 8px"
                >
                  <a-input
                    v-ant-ref="(c) => (searchInput = c)"
                    :placeholder="`${$t('scolarite.recherche')} ${
                      column.title
                    }`"
                    :value="selectedKeys[0]"
                    style="width: 188px; margin-bottom: 8px; display: block"
                    @change="
                      (e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    "
                    @pressEnter="
                      () =>
                        handleSearch(selectedKeys, confirm, column.dataIndex)
                    "
                  />
                  <a-button
                    type="primary"
                    icon="search"
                    size="small"
                    style="width: 90px; margin-right: 8px"
                    @click="
                      () =>
                        handleSearch(selectedKeys, confirm, column.dataIndex)
                    "
                    >{{ $t("action.imprimer") }}</a-button
                  >
                  <a-button
                    size="small"
                    style="width: 90px"
                    @click="() => handleReset(clearFilters)"
                    >{{ $t("action.reinitialiser") }}</a-button
                  >
                </div>
                <a-icon
                  slot="filterIcon"
                  slot-scope="filtered"
                  type="search"
                  :style="{ color: filtered ? '#108ee9' : undefined }"
                />
              </a-table>
            </div>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="card" v-if="selectedClasse">
            <attendanceChart
              :data="attendanceChartData"
              :className="selectedClassName"
              :classLevel="selectedLevel"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable */
//ANCHOR class/month filter to this view: DONE

import apiClient from "@/services/axios";
import attendance from "./components/attendance";
import attendanceChart from "./components/attendanceChart";
import { mapState } from "vuex";
import JsPDF from "jspdf";
import "jspdf-autotable";
import { notification } from "ant-design-vue";
import moment from "moment";
import { generateHistoryPdf as generateHistoryPdfDocument } from "./historyPdfGenerator";

export default {
  computed: {
    ...mapState(["settings", "user"]),
    columns() {
      return [
        {
          title: this.$t("bulletin.nom"),
          dataIndex: "name",
          key: "name",
          scopedSlots: {
            customRender: "name",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
          onFilter: (value, record) =>
            record.fullName
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("assiduite.assiduite"),
          dataIndex: "mark",
          scopedSlots: { customRender: "mark" },
        },
      ];
    },
  },
  components: {
    attendance: attendance,
    attendanceChart,
  },
  async created() {
    this.tableLoading = true;

    await apiClient
      .post("/classrooms/filter", {
        query: {
          status: "active",
        },
        aggregation: {
          $project: {
            _id: 1,
            name: 1,
            level: 1,
          },
        },
      })
      .then((res) => (this.classes = res.data));

    this.filtredTable = this.activeData;

    this.schoolType = this.user.building.filter(
      (el) => el.dbName == this.settings.activeBuilding
    )[0].type;
    if (!this.schoolType)
      notification.warning({
        message: this.$t("bulletin.typeIntrouvable"),
        description: this.$t("bulletin.saisirSchoolType"),
      });
  },
  data() {
    return {
      printLoading: false,
      historyPrintLoading: false,
      showHistoryModal: false,
      startDate: null,
      endDate: null,
      schoolType: null,
      filtredTable: [],
      selectedSession: this.$t("emploi.seanceListe"),
      selectedDate: null,
      selectedStudent: "",
      selectedStudentName: "",
      selectedSessionName: "",
      studentLoading: false,
      sessionLoading: false,
      selectedTrimester: "1",
      selectedClasse: null,
      tableLoading: false,
      activeData: [],
      filters: {
        classe: false,
        classe_val: null,
        month: false,
        month_val: null,
      },
      rowData: [],
      data1: null,
      classes: [],
      sessionList: [],
      historySessionsList: [],
      historyAttendanceData: {},
      attendanceChartData: [],
      attendanceData: [],
      editable: false,
      searchText: "",
      searchInput: null,
      searchedColumn: "",
      listModules: [],
      selectedLevel: null,
      selectedClassName: "",
    };
  },
  methods: {
    moment,
    normalizeId(value) {
      if (!value) return null;
      if (typeof value === "string") return value;
      if (typeof value === "number") return String(value);
      if (typeof value === "object") {
        if (value._id) return value._id;
        if (value.id) return value.id;
      }
      return null;
    },
    tableChanged(pagination, filters, sorter, extra) {
      this.filtredTable = extra.currentDataSource;
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },

    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },

    async handleClassChange(on, value) {
      this.selectedSession = null;
      this.sessionList = [];
      this.selectedClasse = value;
      this.selectedClassName = this.classes.find(
        (item) => item._id === value
      ).name;
      this.selectedLevel = this.classes.find(
        (item) => item._id === value
      ).level;
      this.selectedDate = moment();
      this.handleDateChange();
      let match = {};
      match[`schoolarYearsHistory.${this.settings.activeSchoolarYear}`] = value;
      await apiClient
        .post("/students/filter", {
          query: { status: "active" },
          aggregation: [
            {
              $match: match,
            },
            {
              $set: {
                classRoom: {
                  $convert: {
                    input: `$schoolarYearsHistory.${this.settings.activeSchoolarYear}`,
                    to: "objectId",
                    onError: null,
                    onNull: null,
                  },
                },
              },
            },
            {
              $lookup: {
                from: "classrooms",
                localField: "classRoom",
                foreignField: "_id",
                as: "classroom",
              },
            },
            {
              $project: {
                _id: 1,
                firstName: 1,
                middleName: 1,
                lastName: 1,
                gender: 1,
                classroom: {
                  _id: 1,
                  name: 1,
                },
              },
            },
          ],
        })
        .then(({ data }) => {
          this.rowData = [];
          data.map((elem) => {
            try {
              this.rowData.push({
                _id: elem._id,
                key: elem._id,
                fullName: elem.firstName + (elem.middleName ? " " + elem.middleName : "") + " " + elem.lastName,
                classroom: elem.classroom[0].name,
                classroom_id: elem.classroom[0]._id,
                gender: elem.gender,
              });
            } catch {}
          });
          this.activeData = this.rowData;
          this.tableLoading = false;
          this.filtredTable = this.activeData;
        });

      apiClient
        .post("/attendance/getAttendance", {
          classroom: this.selectedClasse,
        })
        .then(({ data }) => {
          this.attendanceChartData = data;
        });
    },

    async handleDateChange() {
      this.sessionList = [];
      this.sessionLoading = true;
      const startOfDay = moment(this.selectedDate).startOf("day").toISOString();
      const endOfDay = moment(this.selectedDate).endOf("day").toISOString();

      apiClient
        .post("/schedules/classroom/" + this.selectedClasse, {
          startDate: startOfDay,
          endDate: endOfDay,
          canceled: false,
        })
        .then(({ data }) => {
          this.sessionList = [];
          data.schedules.map((s) => {
            if (!this.sessionList.find((d) => d._id == s._id)) {
              if (s.moduleGeneral && s.moduleGeneral.name) {
                s.subject = s.moduleGeneral;
              }
              this.sessionList.push(s);
            }
          });
          this.sessionLoading = false;
          this.selectedSession = "";
        })
        .catch((e) => {});
    },

    async handleSessionChange() {
      this.tableLoading = true;
      this.selectedSessionName = this.sessionList.find(
        (s) => s._id == this.selectedSession
      ).name;
      const todayDate = moment(this.selectedDate).format("YYYY-MM-DD");
      const tomorrowDate = moment(this.selectedDate)
        .add(1, "d")
        .format("YYYY-MM-DD");
      apiClient
        // .post("/attendance/filter", {
        //   query: {
        //     schedule: this.selectedSession,
        //     // date: {
        //     //   $gte: todayDate,
        //     //   $lt: tomorrowDate,
        //     // },
        //   },
        // })
        // .then(({ data }) => {
        //   this.attendanceData = data;
        // })
        // .finally(() => {
        //   this.tableLoading = false;
        // });
        .post("/attendance/getAttendance", {
          date: {
            gte: todayDate,
            lte: tomorrowDate,
          },
          schedule: this.selectedSession,
        })
        .then(({ data }) => {
          this.attendanceData = data;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    getStudentAttendance(studentID) {
      const normalizedStudentId = this.normalizeId(studentID);
      if (!normalizedStudentId) {
        return "Présent";
      }
      const attend = this.attendanceData.find(
        (at) => this.normalizeId(at.student) === normalizedStudentId
      );
      return attend ? attend.type : "Présent";
    },
    getStudentAttendanceId(studentID) {
      const normalizedStudentId = this.normalizeId(studentID);
      if (!normalizedStudentId) {
        return null;
      }
      const attend = this.attendanceData.find(
        (at) => this.normalizeId(at.student) === normalizedStudentId
      );
      return attend ? attend._id : null;
    },

    handleAttendanceUpdate(updatedAttendance) {
      const normalizedStudentId = this.normalizeId(updatedAttendance.student);
      const index = this.attendanceData.findIndex(
        (at) => this.normalizeId(at.student) === normalizedStudentId
      );

      if (index !== -1) {
        this.$set(this.attendanceData, index, updatedAttendance);
      } else {
        this.attendanceData.push(updatedAttendance);
      }
    },

    getStudentAttendanceTranslated(studentID) {
      const attendance = this.getStudentAttendance(studentID);
      if (attendance === "Retard") {
        return this.$t("assiduite.retard");
      } else if (attendance === "Absence") {
        return this.$t("assiduite.absence");
      } else {
        return this.$t("assiduite.present");
      }
    },

    async generatePdf() {
      this.$gtag.event("Imp assiduités", {
        event_category: "Impression PDF",
        event_label: "Assiduités section",
        value: 1,
      });

      this.printLoading = true;
      const isArabic = this.$i18n.locale === "ar-AR";

      // Helper function to reverse array if Arabic
      const reverseIfArabic = (arr) => (isArabic ? arr.slice().reverse() : arr);

      let arrayOfImages = this.settings.image;
      for (var i = 0; i < arrayOfImages.length; i++) {
        if (this.settings.activeBuilding === arrayOfImages[i].db) {
          var imgData = new Image();
          imgData.src = arrayOfImages[i].logo;
        }
      }
      const doc = new JsPDF();
      const pdf_width = doc.internal.pageSize.width;

      doc.setFont("Amiri");

      var date = new Date(this.selectedDate);
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };

      const titleWidth = doc.getTextWidth(this.selectedClassName);
      const titleX = (pdf_width - titleWidth) / 2;

      doc.setFontSize(15);
      doc.setFont("Amiri", "Bold");
      doc.text(titleX, 22, this.selectedClassName);
      doc.setFont("Amiri", "normal");

      doc.setFontSize(12);
      const sessionWidth = doc.getTextWidth(this.selectedSessionName);
      const sessionX = (pdf_width - sessionWidth) / 2;
      doc.text(sessionX, 29, this.selectedSessionName);

      doc.setFontSize(10);

      // Position logo and date (same format as pdfHeader)
      doc.addImage(imgData, "JPEG", isArabic ? pdf_width - 35 : 15, 5, 20, 20);
      doc.setFontSize(8);
      const callSheetText =
        this.$t("assiduite.callSheet") +
        " : " +
        date.toLocaleDateString(this.$i18n.locale, options);
      const callSheetWidth = doc.getTextWidth(callSheetText);
      doc.text(
        isArabic ? 15 : pdf_width - callSheetWidth - 15,
        15,
        callSheetText
      );
      var arr = [];
      const array = [];
      var counter = 1;
      for (let i = 0; i < this.activeData.length; i++) {
        arr.push(counter);
        arr.push(this.activeData[i].fullName);
        arr.push(this.getStudentAttendanceTranslated(this.activeData[i]._id));

        // Reverse for Arabic if needed
        if (isArabic) {
          arr.reverse();
        }

        array.push(arr);
        arr = [];
        counter++;
      }
      doc.autoTable({
        theme: "grid",
        styles: { font: "Amiri", halign: isArabic ? "right" : "left" },
        headStyles: { halign: isArabic ? "right" : "left" },
        bodyStyles: { halign: isArabic ? "right" : "left" },
        startY: 45,
        head: [
          reverseIfArabic([
            this.$t("paiement.num"),
            this.$t("bulletin.nom"),
            this.$t("assiduite.assiduite"),
          ]),
        ],
        body: array,
        foot: [],
        columnStyles: {
          0: { halign: isArabic ? "right" : "center" }, // Number column
          1: { halign: isArabic ? "right" : "left" }, // Name column
          2: { halign: isArabic ? "right" : "left" }, // Attendance column
        },
      });

      this.printLoading = false;
      doc.save(
        this.selectedClassName +
          " - " +
          this.selectedSessionName +
          " - " +
          date.toLocaleDateString(this.$i18n.locale, options)
      );
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    openHistoryModal() {
      this.showHistoryModal = true;
      this.startDate = null;
      this.endDate = null;
    },
    closeHistoryModal() {
      this.showHistoryModal = false;
      this.startDate = null;
      this.endDate = null;
    },
    async fetchAllSessionsInRange() {
      if (!this.selectedClasse || !this.startDate || !this.endDate) {
        return [];
      }

      const startOfRange = moment(this.startDate).startOf("day").toISOString();
      const endOfRange = moment(this.endDate).endOf("day").toISOString();

      const query = {
        classeRoom: this.selectedClasse,
        day: {
          $gte: startOfRange,
          $lte: endOfRange,
        },
        status: { $ne: "inactive" },
      };

      try {
        const { data } = await apiClient.post("/schedules/filter", {
          query: query,
        });

        const sessionsMap = new Map();

        data.forEach((s) => {
          if (s.moduleGeneral && s.moduleGeneral.name) {
            s.subject = s.moduleGeneral;
          }
          if (!s.subject || s.subject.status === "inactive") {
            return;
          }
          const sessionDate = moment.utc(s.day).format("YYYY-MM-DD");
          const uniqueKey = `${s._id}_${sessionDate}`;

          if (!sessionsMap.has(uniqueKey)) {
            sessionsMap.set(uniqueKey, {
              _id: s._id,
              scheduleId: s._id,
              subject: s.subject,
              sessionName: s.name,
              day: s.day,
              date: sessionDate,
              formattedDate: moment.utc(s.day).format("DD/MM/YYYY"),
            });
          }
        });

        // Convert map to array and sort by date
        this.historySessionsList = Array.from(sessionsMap.values()).sort(
          (a, b) => moment(a.date).valueOf() - moment(b.date).valueOf()
        );

        return this.historySessionsList;
      } catch (error) {
        console.error("Error fetching sessions in range:", error);
        notification.error({
          message: this.$t("error.erreur"),
          description:
            this.$t("error.erreurRecuperationSeances") ||
            this.$t("assiduite.erreurRecuperationSeances"),
        });
        return [];
      }
    },

    async fetchAllAttendanceInRange() {
      if (!this.selectedClasse || !this.startDate || !this.endDate) {
        return {};
      }

      const startDateStr = moment(this.startDate).format("YYYY-MM-DD");
      const endDateStr = moment(this.endDate)
        .add(1, "day")
        .format("YYYY-MM-DD");

      try {
        const { data } = await apiClient.post("/attendance/getAttendance", {
          date: {
            gte: startDateStr,
            lte: endDateStr,
          },
        });
        const attendanceMap = {};
        data.forEach((att) => {
          if (!att.schedule) {
            return;
          }

          let classeRoomId = null;
          if (att.schedule.classeRoom) {
            classeRoomId =
              typeof att.schedule.classeRoom === "string"
                ? att.schedule.classeRoom
                : att.schedule.classeRoom._id || att.schedule.classeRoom;
          } else if (att.schedule.classRoomId) {
            classeRoomId = att.schedule.classRoomId;
          }

          if (
            !classeRoomId ||
            String(classeRoomId) !== String(this.selectedClasse)
          ) {
            return;
          }

          let scheduleId = att.schedule._id || att.schedule;
          if (typeof scheduleId !== "string") {
            scheduleId = scheduleId.toString();
          }
          const attendanceDate = moment.utc(att.date).format("YYYY-MM-DD");
          const studentId = String(att.student);

          const uniqueKey = `${studentId}_${scheduleId}_${attendanceDate}`;

          attendanceMap[uniqueKey] = {
            _id: att._id,
            studentId: studentId,
            scheduleId: scheduleId,
            date: attendanceDate,
            formattedDate: moment.utc(att.date).format("DD/MM/YYYY"),
            type: att.type || "Présent",
          };
        });

        this.historyAttendanceData = attendanceMap;
        return attendanceMap;
      } catch (error) {
        console.error("Error fetching attendance in range:", error);
        notification.error({
          message: this.$t("error.erreur"),
          description:
            this.$t("error.erreurRecuperationAssiduite") ||
            this.$t("assiduite.erreurRecuperationDonnees"),
        });
        return {};
      }
    },

    getHistoryAttendance(studentId, scheduleId, date) {
      // Use UTC to match the format used when storing attendance
      const dateStr = moment.utc(date).format("YYYY-MM-DD");
      const key = `${String(studentId)}_${String(scheduleId)}_${dateStr}`;
      let attendance = this.historyAttendanceData[key];
      if (!attendance) {
        const prevDay = moment
          .utc(date)
          .subtract(1, "day")
          .format("YYYY-MM-DD");
        const nextDay = moment.utc(date).add(1, "day").format("YYYY-MM-DD");
        attendance =
          this.historyAttendanceData[
            `${String(studentId)}_${String(scheduleId)}_${prevDay}`
          ] ||
          this.historyAttendanceData[
            `${String(studentId)}_${String(scheduleId)}_${nextDay}`
          ];
      }
      return attendance ? attendance.type : "Présent";
    },

    async generateHistoryPdf() {
      // Validate inputs
      if (!this.selectedClasse || !this.startDate || !this.endDate) {
        notification.warning({
          message: this.$t("error.erreur"),
          description: this.$t("error.selectionnerDates"),
        });
        return;
      }

      // Validate date range
      if (moment(this.startDate).isAfter(this.endDate)) {
        notification.warning({
          message: this.$t("error.erreur"),
          description: this.$t("error.dateDebutApresFin"),
        });
        return;
      }

      this.historyPrintLoading = true;

      try {
        const sessions = await this.fetchAllSessionsInRange();
        await this.fetchAllAttendanceInRange();
        const pdfData = {
          className: this.selectedClassName,
          startDate: moment(this.startDate).format("DD/MM/YYYY"),
          endDate: moment(this.endDate).format("DD/MM/YYYY"),
          period: `${moment(this.startDate).format("DD/MM/YYYY")} - ${moment(
            this.endDate
          ).format("DD/MM/YYYY")}`,
          students: [],
          sessions: sessions,
        };

        this.activeData.forEach((student) => {
          const studentData = {
            id: student._id,
            fullName: student.fullName,
            attendanceBySession: [],
            totals: {
              present: 0,
              absent: 0,
              retard: 0,
              exclus: 0,
            },
          };

          sessions.forEach((session) => {
            const attendanceType = this.getHistoryAttendance(
              student._id,
              session.scheduleId,
              session.date
            );

            studentData.attendanceBySession.push({
              sessionId: session.scheduleId,
              sessionName: session.sessionName,
              date: session.date,
              formattedDate: session.formattedDate,
              type: attendanceType,
            });
            if (attendanceType === "Présent") {
              studentData.totals.present++;
            } else if (attendanceType === "Absence") {
              studentData.totals.absent++;
            } else if (attendanceType === "Retard") {
              studentData.totals.retard++;
            } else if (attendanceType === "Exclus") {
              studentData.totals.exclus++;
            }
          });

          pdfData.students.push(studentData);
        });

        const { doc, filename } = await generateHistoryPdfDocument(
          pdfData,
          this.settings,
          this.$gtag,
          this.$i18n.locale,
          this.$i18n.t.bind(this.$i18n)
        );

        doc.save(filename);

        this.closeHistoryModal();

        notification.success({
          message: this.$t("action.succes"),
          description: this.$t("action.pdfGenereAvecSucces"),
        });
      } catch (error) {
        notification.error({
          message: this.$t("error.erreur"),
          description: this.$t("error.erreurGenerationPdf"),
        });
      } finally {
        this.historyPrintLoading = false;
      }
    },
  },
};
</script>
<style scoped>
.arabic-font {
  font-size: 14px !important;
  font-family: Verdana, Geneva, Tahoma, sans-serif !important;
}
</style>
